import { __assign, __rest } from "tslib";
import { capitalize } from '@material-ui/core/utils';
import clsx from 'clsx';
import React, { createContext, forwardRef, useContext } from 'react';
import { combineProps } from '../../foundation';
import { RcBox } from '../Box';
import { DefaultDotComponent } from './styles';
import { RcBadgeClasses } from './utils';
export var DotBadgeContext = createContext({});
export var DotBadge = forwardRef(function (_a, ref) {
    var _b;
    var OmitChildren = _a.children, rest = __rest(_a, ["children"]);
    var _c = useContext(DotBadgeContext), anchorOrigin = _c.anchorOrigin, dotComponent = _c.dotComponent, dotProps = _c.dotProps, invisibleProp = _c.invisible, badgeContent = _c.badgeContent, showZero = _c.showZero, overlap = _c.overlap, children = _c.children;
    // sync with mui
    var invisible = invisibleProp;
    if (typeof invisibleProp !== 'boolean' && badgeContent === 0 && !showZero) {
        invisible = true;
    }
    var _d = anchorOrigin, horizontal = _d.horizontal, vertical = _d.vertical;
    var addClassName = "MuiBadge-anchorOrigin" + capitalize(vertical) + capitalize(horizontal) + capitalize(overlap);
    var DotComponent = dotComponent !== null && dotComponent !== void 0 ? dotComponent : DefaultDotComponent;
    var applyDotProps = combineProps({
        className: clsx(addClassName, RcBadgeClasses.badge, (_b = {},
            _b[RcBadgeClasses.invisible] = invisible,
            _b['MuiBadge-invisible'] = invisible,
            _b)),
    }, dotProps);
    return (React.createElement("div", __assign({}, rest, { ref: ref }),
        children,
        dotComponent !== null && (React.createElement(RcBox, { position: "absolute", zIndex: "1", clone: true },
            React.createElement(DotComponent, __assign({}, applyDotProps))))));
});
